<template>
  <div class="col s12 main-col-style">
    <div v-show="loading">
      <div class="row">
        <div class="col s4 offset-s4" >
          <h5 class="loading-header">Getting user data</h5>
          <ul class="collection collection-clouds">
            <li class="collection-item collection-item-clouds grey-color">
              <div class="progression-text">{{ loadingStatus }}
                <a
                  href="#!"
                  class="secondary-content">
                  <i
                    class="material-icons blue-color"
                    v-show="loading">
                    cloud_download
                    <div class="progress progression-cloud">
                      <div class="indeterminate blue-color-background"/>
                    </div>
                  </i>
                  <i
                    class="material-icons blue-color"
                    v-show="!loading">done</i>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="row no-margin">
      <div class="col s12" v-show="user && !loading">
        <div class="row">
          <div class="col s12">
            <p @click="navigateToUsers()" class="clickable user-name-style"><u>users</u></p><p class="user-name-style">&nbsp;/ edituser</p>
          </div>
        </div>
        <div class="row">
          <div class="col s12">
            <div class="divider"></div>
            <div class="section">
              <h5>{{ user.UserV61id !== -1 ? 'Edit' : 'New' }} user {{ user.FirstName }} {{ user.MiddleName }} {{ user.LastName }}</h5>
            </div>
          </div>
        </div>

        <div class="row">
          <div>
            <a class="waves-effect waves-light btn button-save-style" @click="saveUserAndAlarmSettings()">Save<i class="material-icons right">save</i></a>
            <a class="waves-effect waves-light btn button-cancel-style" @click="navigateToUsers()">Cancel<i class="material-icons right">cancel</i></a>
          </div>
        </div>

        <div class="row">
          <div class="col s12">
            <div class="divider"></div>
            <ul class="tabs">
              <li class="tab col"><a v-bind:class="{'active': activeTab === 'General'}" class="clickable" @click="activeTab = 'General'">General</a></li>
              <li class="tab col"><a v-bind:class="{'active': activeTab === 'Department-visibility'}" class="clickable" @click="activeTab = 'Department-visibility'">Department-visibility</a></li>
              <li class="tab col"><a v-bind:class="{'active': activeTab === 'Notifications'}" class="clickable" @click="activeTab = 'Notifications'">Notifications</a></li>
              <li class="tab col"><a v-show="user.DashboardId !== null" v-bind:class="{'active': activeTab === 'Dashboard'}" class="clickable" @click="activeTab = 'Dashboard'">Dashboard</a></li>
            </ul>
            <div class="divider"></div>
          </div>
        </div>
        <div class="row">
          <div class="col s12">
            <general
              v-show="activeTab === 'General'"
              :currentUser="currentUser"
              :user="user"
              :languages="languages"
              :organisations="organisations"></general>

            <notifications
              v-show="activeTab === 'Notifications'"
              :currentUser="currentUser"
              :user="user"
              :regions="regionsNotification"
              :alarmsettings="alarmsettings"></notifications>

            <department-visibility
              v-show="activeTab === 'Department-visibility'"
              :regions="regionsDepartmentVisibility"
              :currentUser="currentUser"
              :user="user"></department-visibility>

            <dashboard
              v-show="user.DashboardId !== null && activeTab === 'Dashboard'"
              :currentUser="currentUser"
              :user="user"
              :dashboards="dashboards"></dashboard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import M from 'materialize-css'
import moment from 'moment'
import LanguageService from '@/services/api/LanguageService'
import _General from './_General'
import _Notifications from './_Notificiations'
import _Dashboard from './_Dashboard'
import _DepartmentVisibility from './_Department-visibility'
import Router from '@/router'
import OrganisationsAPI from '@/services/api/OrganisationsApi'
import UsersApi from '@/services/api/UsersApi'
import AuthenticationService from '@/services/AuthenticationService'
import RegionsService from '@/services/api/RegionsApi'
import DepartmentsApi from '@/services/api/DepartmentsApi'
import AssetsApi from '@/services/api/AssetsApi'
import NotificationsService from '@/services/r8/NotificationsService'
import DashboardService from '../../services/DashboardService'

export default {
  components: {
    'general': _General,
    'notifications': _Notifications,
    'department-visibility': _DepartmentVisibility,
    'dashboard': _Dashboard
  },
  data: function () {
    return {
      expirationDate: moment().add(1, 'years').toDate(),
      loading: true,
      loadingStatus: 'Loading user data',
      regionsNotification: null,
      regionsDepartmentVisibility: [],
      currentUser: AuthenticationService.getUser(),
      isNewUser: false,
      user: {
        'UserV61id': null,
        'LogonName': null,
        'PasswordHash': null,
        'AccountExpires': moment().add(1, 'years').toDate(),
        'FirstName': null,
        'MiddleName': null,
        'LastName': null,
        'LanguageId': null,
        'Phone': null,
        'MobilePhone': null,
        'Email': null,
        'UserStatus': null,
        'OrganisationId': null,
        'SystemRoleId': null,
        'UsergroupId': null,
        'IsDisclaimerOk': false,
        'IsDisclaimerOkdatetime': null,
        'LoginCount': null,
        'LastLoginDatetime': null,
        'DepartmentIds': [],
        'DashboardId': null
      },
      alarmsettings: null,
      alarmsettingsChanged: false,
      activeTab: 'General',
      languages: [],
      organisations: [],
      dashboards: []
    }
  },
  watch: {
    alarmsettings: {
      handler: function (newValue, oldValue) {
        if (this.alarmsettings !== null && oldValue !== null) {
          this.alarmsettingsChanged = true
        }
      },
      deep: true
    }
  },
  beforeMount: async function () {
    await this.load()
  },
  updated: function () {
    M.FormSelect.init(document.querySelectorAll('select'))
    M.Tabs.init(document.querySelectorAll('tabs'))
  },
  methods: {
    load: async function () {
      // Get valid regions for user
      var userDepartments
      await DepartmentsApi.getDepartments(true).then(r => {
        userDepartments = r.data
      })

      var userRegions = []
      if (userDepartments.length > 0) {
        userDepartments.forEach(ur => {
          if (userRegions.indexOf(ur.RegionId) === -1) userRegions.push(ur.RegionId)
        })
      }
      this.loading = true
      this.loadingStatus = 'loading regions'
      this.regionsNotification = (await RegionsService.getRegions()).data
      this.loadingStatus = 'loading departments'
      this.regionsDepartmentVisibility = (await RegionsService.getRegions()).data
      if (this.$route.name === 'new-user') {
        this.isNewUser = true
        this.user = {
          'UserV61id': -1,
          'LogonName': '',
          'PasswordHash': null,
          'AccountExpires': moment().add(1, 'years').toDate(),
          'FirstName': '',
          'MiddleName': null,
          'LastName': '',
          'LanguageId': -1,
          'Phone': null,
          'MobilePhone': null,
          'Email': '',
          'UserStatus': 1,
          'OrganisationId': this.currentUser.OrganisationId,
          'SystemRoleId': -1,
          'UsergroupId': -1,
          'IsDisclaimerOk': false,
          'IsDisclaimerOkdatetime': '',
          'LoginCount': -1,
          'LastLoginDatetime': '',
          'DepartmentIds': [],
          'DashboardId': null
        }
        this.alarmsettings = {
          ComplexIds: [],
          DepartmentIds: [],
          RegionIds: []
        }
        this.loadingStatus = 'loading organisations'
        this.organisations = (await OrganisationsAPI.getOrganisations()).data
      } else {
        this.loadingStatus = 'loading extra user data'
        this.user = (await UsersApi.getUser(this.$route.params.id)).data
        this.loadingStatus = 'loading alarm settings'
        this.alarmsettings = (await UsersApi.getUserAlarmSettings(this.$route.params.id)).data
        this.loadingStatus = 'loading organisations'
        this.organisations = (await OrganisationsAPI.getOrganisations()).data
      }
      this.loadingStatus = 'loading languages'
      this.languages = (await LanguageService.getLanguagesV2()).data

      this.loadingStatus = 'loading dashboards'
      this.dashboards = (await DashboardService.getDashboards(this.currentUser.UserId)).data

      this.loading = false
    },
    saveAlarmsettings: async function () {
      if (this.alarmsettings !== null) {
        // Save alarm settings in R7
        await UsersApi.saveUserAlarmSettings(this.alarmsettings, this.user.UserV61id).then(result => {
          this.$notify({
            group: 'alerts',
            type: 'success',
            title: 'Alarmsettings',
            text: 'Alarmsettings saved'
          })
        }).catch(e => {
          this.$notify({
            group: 'alerts',
            type: 'error',
            title: 'Saving alarmsettings failed',
            text: 'Unknown error occured'
          })
        })

        // We don't want to update R8 when user is deleted (everything is taken care of in the user delete endpoint of the notifications service)
        if (this.user.UserStatus !== 0) {
          // Gather all unique id's of the assets which are selected by regions, departments and complexes
          let assets = await AssetsApi.getFiltered(
            this.alarmsettings.RegionIds,
            this.alarmsettings.DepartmentIds,
            this.alarmsettings.ComplexIds
          )

          // Create a distinct list of asset ids
          const assetIds = assets.data
            .map(item => item.UniqueId)
            .filter(id => id)

          // Save alarm settings to R8
          NotificationsService.postNotifications(
            this.user.Email,
            assetIds
          ).then(result => {
            this.$notify({
              group: 'alerts',
              type: 'success',
              title: 'Alarmsettings',
              text: 'Alarmsettings saved to R8'
            })
          }).catch(e => {
            this.$notify({
              group: 'alerts',
              type: 'error',
              title: 'Saving alarmsettings to R8 failed',
              text: 'Unknown error occurred'
            })
          })
        }
      }
    },
    checkIfInputIsValid: function () {
      if (this.user.AccountExpires === null || this.formatDateTime(this.user.AccountExpires) === 'Invalid date') {
        this.$notify({
          group: 'alerts',
          type: 'error',
          title: 'Invalid date',
          text: 'Expiration date is invalid'
        })
        return false
      }

      if (new Date(this.user.AccountExpires) <= new Date()) {
        this.$notify({
          group: 'alerts',
          type: 'error',
          title: 'Invalid date',
          text: 'Expiration date cannot be in the past'
        })
        return false
      }

      if (this.user.FirstName === '') {
        this.$notify({
          group: 'alerts',
          type: 'error',
          title: 'Firstname required',
          text: 'Please enter a Firstname'
        })
        return false
      }

      if (this.user.LastName === '') {
        this.$notify({
          group: 'alerts',
          type: 'error',
          title: 'Lastname required',
          text: 'Please enter a Lastname'
        })
        return false
      }

      if (this.user.LanguageId === -1) {
        this.$notify({
          group: 'alerts',
          type: 'error',
          title: 'Language required',
          text: 'Please select a language'
        })
        return false
      }

      if (this.user.SystemRoleId === -1) {
        this.$notify({
          group: 'alerts',
          type: 'error',
          title: 'Systemrole required',
          text: 'Please select a system role'
        })
        return false
      }

      if (this.user.Email === '') {
        this.$notify({
          group: 'alerts',
          type: 'error',
          title: 'Email is required',
          text: 'Please enter the email address'
        })
        return false
      }

      if (this.user.PasswordHash === null && this.isNewUser) {
        this.$notify({
          group: 'alerts',
          type: 'error',
          title: 'Password is required',
          text: 'Please set a user password'
        })
        return false
      }

      return true
    },
    saveUser: async function () {
      if (this.checkIfInputIsValid()) {
        try {
          const result = await UsersApi.postUser(this.user)
          this.user.UserV61id = result.data.UserV61id
          this.$notify({
            group: 'alerts',
            type: 'success',
            title: 'Save user',
            text: 'User saved'
          })
          return true
        } catch (e) {
          this.$notify({
            group: 'alerts',
            type: 'error',
            title: 'Saving user failed',
            text: e.response.data
          })
          return false
        }
      } else {
        return false
      }
    },
    saveUserAndAlarmSettings: async function () {
      const result = await this.saveUser()
      // Clean up alarm settings when user is deleted
      if (this.user.UserStatus === 0) {
        this.alarmsettings = {
          ComplexIds: [],
          DepartmentIds: [],
          RegionIds: []
        }
      }
      if (result) {
        await this.saveAlarmsettings()
      }
    },
    formatDateTime: (dateTime) => {
      return moment(String(dateTime)).format('DD-MM-YYYY')
    },
    navigateToUsers: function () {
      if (this.currentUser.SystemRoleId !== 1) {
        Router.push({
          name: 'users'
        })
      } else {
        Router.go(-1)
      }
    }
  }
}
</script>

<style scoped>
.main-col-style { overflow-y: scroll; max-height: inherit; background-color: white; }
.user-name-style { display: inline-block; margin-bottom: 0px }
.button-save-style { min-width: 150px; margin-right: 12px; margin-left: 12px }
.button-cancel-style { min-width: 150px; margin-right: 12px }

p {
  margin-top: 12px;
  margin-bottom: 12px;
}

.inline-icon {
   vertical-align: bottom;
}

/* BUTTON */
.btn-floating:hover {
  background-color: #F39810;
}

.btn:hover, .btn-large:hover, .btn-small:hover {
  background-color: #F39810;
}

.btn, .btn-large, .btn-small {
  background-color: #56CCF2;
}

[type="checkbox"]:indeterminate+span:not(.lever):before {
  border-right: 2px solid #56CCF2;
}

[type="checkbox"]:not(:checked), [type="checkbox"]:checked {
    position: fixed !important;
    opacity: 0;
    pointer-events: none;
}

.tabs .active {
    border-bottom: 2px solid #56ccf2;
}

.collection-item-clouds {
  padding-left: 0px;
  padding-right: 0px;
  border: 0px;
}

.collection-clouds {
  padding-left: 53px;
  padding-right: 49px;
  border: 0px;
}

.progression-cloud {
  background-color: white;
  height: 2px;
}

.progression-text {
  margin-left: 45px;
  position: relative;right: 2em;
}

.loading-header {
  color: #56CCF2;
  padding-top: 144px;
  padding-left: 53px;
  padding-right: 49px;
}
</style>



// WEBPACK FOOTER //
// src/pages/users/User.vue